import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProductsRoutingModule } from "app/products/productsrouting.module";

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProductLeadPopupComponent } from "app/products/product-lead-popup/product-lead-popup.component";
import { LeadFormComponent } from "app/products/lead-form/lead-form.component";
import { NKDatetimeModule } from "ng2-datetime/ng2-datetime";
import { SharedModule } from "app/shared/shared.module";
import { ProductHomeComponent } from './product-home/product-home.component';
import { ProductService } from "app/products/service/product.service";
import { LoanOfferGenService } from "app/loan/services/loan-offer-gen.service";
import { YoutubePlayerMiniModule }  from 'ng2-youtube-player-mini';
import { ProductListingPageComponent } from './product-listing-page/product-listing-page.component';

@NgModule({
  imports: [
    CommonModule,
    ProductsRoutingModule,
    NKDatetimeModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    YoutubePlayerMiniModule
  ],
  declarations: [
      ProductLeadPopupComponent,
      LeadFormComponent,
      ProductHomeComponent,
      ProductListingPageComponent
  ],
  exports:[
    ProductLeadPopupComponent,
    ProductListingPageComponent
  ],
  entryComponents: [ProductLeadPopupComponent],
  providers:[
    ProductService,
    LoanOfferGenService
  ]
})
export class ProductsModule { }



// WEBPACK FOOTER //
// ./src/app/products/products.module.ts